import type { QuestFeStatus } from '@aegislab/shared';
import { statusLabels } from '../../../config/constants';
import * as s from './StatusBadge.css';

interface StatusBadgeProps {
  status: QuestFeStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** 표시 문구 override — 색은 status 유지, 텍스트만 교체 (미주입 시 statusLabels[status]). */
  label?: string;
}

export function StatusBadge({ status, size = 'sm', className, label }: StatusBadgeProps) {
  return (
    <span
      className={`${s.badge({ size })} ${s.statusColors[status]}${className ? ` ${className}` : ''}`}
    >
      {label ?? statusLabels[status]}
    </span>
  );
}
